import { useContext } from 'react';

import AuthContext from 'src/contexts/auth';

const useAuth = () => useContext(AuthContext);

export default useAuth;
